
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { LoadingModule } from '~common-store/modules/loading';
@Component
export default class CommonLoading extends Vue {
    get showLoading() {
        return LoadingModule.loading;
    }
}
